interface SelectSurfaceLayout {
  desktopPanelClassName: string;
  desktopOptionsClassName: string;
}

export function selectSurfaceLayout(
  fullWidthPanelClassName: string,
  compactPanelClassName: string,
  isFullWidth: boolean,
): SelectSurfaceLayout {
  return {
    desktopPanelClassName: isFullWidth ? fullWidthPanelClassName : compactPanelClassName,
    desktopOptionsClassName: isFullWidth ? "max-h-48" : "max-h-60",
  };
}
